import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { isRingCentralEnabledForUser } from '@/lib/featureFlags';
import { selectUser } from '@/state/selectors/root-selectors';

export type TelephonyProvider = 'ringcentral' | 'dialpad';

interface TelephonyProviderInfo {
  provider: TelephonyProvider;
  isRingCentral: boolean;
  isDialpad: boolean;
  providerLabel: string;
  callLabel: string;
}

export const useTelephonyProvider = (): TelephonyProviderInfo => {
  const user = useSelector(selectUser);

  return useMemo(() => {
    const rc = isRingCentralEnabledForUser(user?.email);
    return {
      provider: rc ? 'ringcentral' : 'dialpad',
      isRingCentral: rc,
      isDialpad: !rc,
      providerLabel: rc ? 'RingCentral' : 'Dialpad',
      callLabel: rc ? 'Phone Call' : 'Phone Call',
    };
  }, [user?.email]);
};
